<div class="changelog-entry">
  <div class="changelog-row">
    <div class="changelog-row-meta">
      <gc-text [variant]="'paragraphHeading'">{{ entry().date }}</gc-text>
    </div>
    <div class="changelog-row-main">
      <gc-text [variant]="'paragraphHeading'">{{ entry().title }}</gc-text>
      <gc-text [innerHTML]="entry().body" />

      @if (entry().imageUrl; as imageUrl) {
        <img
          class="changelog-entry-image"
          [src]="imageUrl"
          [alt]="entry().imageAlt ?? entry().title"
          [style.--changelog-image-width]="
            (entry().widthPercentage ?? 80) + '%'
          "
        />
      }

      @if (safeVideoUrl()) {
        <div class="changelog-entry-video">
          <iframe
            [src]="safeVideoUrl()"
            title="YouTube video player"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share;
            "
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      }
    </div>
  </div>
</div>
